console.log("SHADOW ENGINE LOADED");

function applyShadow(type){

document
.querySelectorAll(".curve-letter")
.forEach(letter=>{

letter.classList.remove(
"soft-shadow",
"drop-shadow",
"offset-shadow"
);

if(type==="none") return;

letter.classList.add(
type + "-shadow"
);

});

}

document.addEventListener(
"DOMContentLoaded",
()=>{

document
.querySelectorAll(
"#shadow-grid .option-card"
)
.forEach(card=>{

card.addEventListener(
"click",
()=>{

const type =
card.dataset.shadow;

console.log(
"SHADOW CLICKED",
type
);

document
.querySelectorAll(
"#shadow-grid .option-card"
)
.forEach(c=>
c.classList.remove("active")
);

card.classList.add("active");

document.getElementById(
"shadowEmbroidery"
).value = type;

applyShadow(type);

}
);

});

});